export const usmle1BiochemModule = {
  id: "biochem",
  title: "Biochemistry",
  sections: [
    {
      type: "text",
      content: `<h3>High Yield Biochemistry</h3>
        <p>This chapter will focus on high-yield biochemistry topics commonly tested on the USMLE Step 1.
       This can be a little dry - but if you take small info in small bites, you'll do great!
        </p>
        <p>We will start with genetics and always include clinical relevance, so the information is not just memorization, but also application.
        </p><p>Lets go!</p>`,
      image: "/images/usmle1/biochemguy.png",
    },
    {
      type: "text",
      content: `<h3>DNA the Blueprint of Life</h3>
      <p></p>`,
    },
    {
      type: "question",
      text: "Rate-limiting enzyme for cholesterol synthesis?",
      options: ["CPS I", "HMG-CoA reductase", "PFK-1", "PDH"],
      correct: 1,
      explanation: "HMG-CoA reductase is the rate-limiting enzyme.",
    },
  ],
};
